/**
 * A custom element that manages a full-screen video modal.
 * Opens via click events on [data-video-modal-trigger] buttons,
 * reading video metadata from data attributes on the trigger.
 */
class VideoModal extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.videoContainer = this.querySelector('.video-modal__content');
    this.closeBtn = this.querySelector('.video-modal__close');

    this.closeBtn?.addEventListener('click', () => this.close());
    this.dialog?.addEventListener('click', (e) => {
      if (e.target === this.dialog) this.close();
    });
    this.dialog?.addEventListener('cancel', () => this.#clearVideo());

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-video-modal-trigger]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      this.open(trigger);
    });
  }

  /**
   * @param {HTMLElement} trigger - The button that was clicked, with data attributes for video info
   */
  open(trigger) {
    const host = trigger.dataset.videoHost;
    const videoId = trigger.dataset.videoId;
    const videoUrl = trigger.dataset.videoUrl;

    this.#clearVideo();

    let videoEl;

    if (host === 'youtube') {
      videoEl = document.createElement('iframe');
      videoEl.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
      videoEl.allow = 'autoplay; encrypted-media';
      videoEl.allowFullscreen = true;
      videoEl.className = 'video-modal__iframe';
    } else if (host === 'vimeo') {
      videoEl = document.createElement('iframe');
      videoEl.src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      videoEl.allow = 'autoplay; encrypted-media';
      videoEl.allowFullscreen = true;
      videoEl.className = 'video-modal__iframe';
    } else if (videoUrl) {
      videoEl = document.createElement('video');
      videoEl.src = videoUrl;
      videoEl.controls = true;
      videoEl.autoplay = true;
      videoEl.playsInline = true;
      videoEl.className = 'video-modal__video';
    }

    if (videoEl) {
      this.videoContainer.appendChild(videoEl);
    }

    this.dialog?.showModal();
  }

  close() {
    this.dialog?.close();
    this.#clearVideo();
  }

  #clearVideo() {
    if (this.videoContainer) {
      this.videoContainer.innerHTML = '';
    }
  }
}

if (!customElements.get('video-modal')) {
  customElements.define('video-modal', VideoModal);
}
